import { Component } from "react"
import Top from "./Top"
import Bottom from "./Bottom"
import "./index.css"
import "./Home.css"
import "./PageLayout.css"

class CourseIntro extends Component {
  componentDidMount() {
    document.documentElement.scrollTop = document.body.scrollTop = 0
  }

  render() {
    return (
      <div>
        <Top />
        <div className="page-container">
          <div className="page-header">
            <h1 className="page-title">课程介绍</h1>
            <p className="page-subtitle">深入了解嵌入式系统设计的核心原理和实际应用</p>
          </div>
          <div className="course-content">
            <h2 className="course-title">嵌入式系统设计原理与应用</h2>
            <p className="course-description">
              课程旨在使学生了解嵌入式系统微机的基本原理，掌握硬件结构、内部资源、指令系统、应用程序设计和应用系统组成等多方面知识，培养学生具有设计基础嵌入式应用系统的能力；本课程注重实际应用，使学生具有一定的嵌入式系统软、硬件设计和开发能力，为今后的工作和后继课程的学习打下良好的技术基础。
            </p>
          </div>
        </div>
        <Bottom />
      </div>
    )
  }
}

export default CourseIntro